import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

// Pages a signed-in person can still open without a finished profile: the step itself, and the
// callback that is busy storing their login.
const OPEN_PATHS = ['/complete-profile', '/auth/callback']

// Until someone who signed in has given their address, every page sends them to the profile step,
// every visit. Renders nothing.
export default function ProfileGate() {
  const { user, isLoading } = useAuth()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading || !user || user.profileComplete !== false) return
    if (OPEN_PATHS.includes(pathname)) return
    navigate('/complete-profile', { replace: true })
  }, [isLoading, user, pathname, navigate])

  return null
}
